import React from 'react';

export default function Quote() {
  return (
    <svg
      width='25'
      height='19'
      viewBox='0 0 25 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M.694 18.23v-5.215q0-2.25.843-4.68A20 20 0 0 1 3.89 3.709Q5.397 1.509 7.265 0l4.295 2.787a27.7 27.7 0 0 0-2.53 4.756q-.998 2.454-.972 5.42v5.268zm12.963 0v-5.215q0-2.25.844-4.68a20 20 0 0 1 2.352-4.627Q18.36 1.509 20.228 0l4.295 2.787a27.7 27.7 0 0 0-2.531 4.756q-.997 2.454-.972 5.42v5.268z'
        fill='currentColor'
      />
    </svg>
  );
}
